export const API_URL = process.env.REACT_APP_BACKEND_API_URL;
export const WEBSOCKET_URL = process.env.REACT_APP_BACKEND_WEBSOCKET_URL;